import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import { companyLegalEntities } from 'modules/core/store/collections/legalEntities'

const legalEntityFilter = (source: ReturnType<typeof useDocumentsDataTable>) => {
  const options = companyLegalEntities(companies.current).map((legalEntity) => ({
    label: legalEntity.attributes.legal_name,
    value: legalEntity.attributes.id,
  }))

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'legal_entity_id',
    path: 'legalEntity',
    title: i18n.t('documents.employee.filters.legal_entity'),
  })
}

export default legalEntityFilter
